import { defineComponent as r, openBlock as n, createBlock as o, unref as p, mergeProps as i, withCtx as d, createElementVNode as e } from "vue";
import { RevIcon as f } from "@ds/components/Icon";
const u = /* @__PURE__ */ r({
  name: "IconReassuranceCertified",
  __name: "IconReassuranceCertified",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const l = t;
    return (s, a) => (n(), o(p(f), i(l, { "view-box": "0 0 48 48" }), {
      default: d(() => [...a[0] || (a[0] = [
        e("g", { "clip-path": "url(#5281555b-7737-406f-8f4e-04735da5d9a1a)" }, [
          e("path", { d: "M47.33 22.34 44 18.69l1.11-4.84a2.51 2.51 0 0 0-1.71-3l-4.77-1.43-1.45-4.75a2.51 2.51 0 0 0-3-1.71l-4.79 1.09-3.64-3.38a2.51 2.51 0 0 0-3.41 0L18.69 4l-4.84-1.08a2.51 2.51 0 0 0-3 1.71L9.42 9.37l-4.75 1.45A2.51 2.51 0 0 0 3 13.77l1.09 4.84-3.42 3.64a2.51 2.51 0 0 0 0 3.41L4 29.31l-1.08 4.84a2.51 2.51 0 0 0 1.71 3l4.74 1.47 1.45 4.75A2.51 2.51 0 0 0 13.77 45l4.84-1 3.64 3.38a2.5 2.5 0 0 0 3.41 0L29.31 44l4.84 1.11a2.51 2.51 0 0 0 3-1.71l1.47-4.74 4.75-1.45a2.51 2.51 0 0 0 1.71-3L44 29.39l3.38-3.64a2.51 2.51 0 0 0-.05-3.41m-15.63-2-8.78 8.72a1 1 0 0 1-1.41 0L16.3 23.9a1 1 0 1 1 1.4-1.42L22.21 27l8.09-8a1 1 0 0 1 1.4 1.42v-.08" })
        ], -1),
        e("defs", null, [
          e("clipPath", { id: "5281555b-7737-406f-8f4e-04735da5d9a1a" }, [
            e("path", { d: "M0 0h48v48H0z" })
          ])
        ], -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
